import { Product } from '../model/product/product.model';

// A converter tool's line, each format with what its numbers are ("HEX (six digit web code) to HSL (hue,
// saturation, lightness)", owner 2026-10-12): the tools page and the home page's web tools box. Any other tool
// keeps its own short description.
const FORMATS: { [ key: string ]: { label: string; what: string } } = {
  'hex': { label: 'HEX', what: 'six digit web code' },
  'rgb': { label: 'RGB', what: 'red, green and blue' },
  'hsl': { label: 'HSL', what: 'hue, saturation, lightness' },
  'hsv': { label: 'HSV', what: 'hue, saturation, value' },
  'hsb': { label: 'HSB', what: 'hue, saturation, brightness' },
  'hwb': { label: 'HWB', what: 'hue, whiteness, blackness' },
  'cmyk': { label: 'CMYK', what: 'cyan, magenta, yellow, black' },
  'oklab': { label: 'OKLab', what: 'perceived lightness, a and b' },
  'oklch': { label: 'OKLCH', what: 'perceived lightness, chroma, hue' },
  'cielab': { label: 'CIELAB', what: 'lightness, a and b' },
  'cielch': { label: 'CIELCH', what: 'lightness, chroma, hue' },
  'cieluv': { label: 'CIELUV', what: 'lightness, u and v' },
  'xyz': { label: 'XYZ', what: 'CIE tristimulus values' },
  'yxy': { label: 'Yxy', what: 'luminance and chromaticity' },
  'display-p3': { label: 'Display P3', what: 'wide gamut RGB' },
  'hunter-lab': { label: 'Hunter Lab', what: 'lightness, a and b' },
};

export function toolLine( tool: Product ): string {
  const parts = tool.key.split( '-to-' );
  const pair = parts.length === 2 ? parts.map( part => FORMATS[ part ] ) : [];
  if ( pair.length !== 2 || !pair.every( Boolean ) ) { return tool.shortDescription || ''; }
  return `${ pair[ 0 ].label } (${ pair[ 0 ].what }) to ${ pair[ 1 ].label } (${ pair[ 1 ].what })`;
}
